import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        partners_mailing: {
          header: 'HEADER',
          status_banned: 'STATUS_BANNED',
          status_unbanned: 'STATUS_UNBANNED',
          subrsribed: 'SUBSCRIBED',
          unsubscribed: 'UNSUBSCRIBED',
          sand_email_btn: 'SEND_BTN',
          emails_for_testing: 'EMAILS_FOR_TESTING',
          sand_test_email_btn: 'SEND_TEST_BTN',
          email_has_been_sent: 'EMAIL_WAS_SENT',
          emails_test_send_description: 'EMAIL_TEST_DESCRIPTION',
          email_subject: 'EMAIL_SUBJECT',
          sender_email: 'SENDER_EMAIL',
          sender_name: 'SENDER_NAME',
          email_body: 'EMAIL_BODY',
          mode_switcher_label: 'MODE_SWITCHER_LABEL',
          mode_editor: 'MODE_EDITOR',
          mode_html: 'MODE_HTML',
          mode_html_textarea_label: 'MODEL_HTML_TEXTAREA',
          mode_preview_email: 'MODE_PREVIEW_EMAIL',
          agree_receive_emails: 'AGREE_RECEIVE',
          tabs: {
            languages: 'TAB_LANGUAGES',
            admins: 'TAB_ADMINS',
            status: 'TAB_STATUS',
            subscription: 'TAB_SUBSCRIPTION',
            affiliates: 'TAB_AFFILIATES',
          },
          modal_window: {
            title: 'MODAL_TITLE',
            message: 'MODAL_MESSAGE',
            answer_yes: 'MODAL_YES',
            answer_no: 'MODAL_NO',
          },
        },
      },
    },
  }));
}
